import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Notify from 'quasar/src/plugins/notify/Notify.js';;
import langRu from "quasar/lang/ru";
import iconSet from "quasar/icon-set/fontawesome-v6";
import "@quasar/extras/fontawesome-v6/fontawesome-v6.css";
import "./assets/styles/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/roboto-font/roboto-font.css";

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    brand: {
      primary: "#0060fe", // синий My Space (как в меню и теме --ms-primary)
      secondary: "#26A69A",
      accent: "#9C27B0",
      dark: "#1d1d1d",
      "dark-page": "#121212",
      positive: "#21BA45",
      negative: "#C10015",
      info: "#31CCEC",
      warning: "#F2C037",
    },
  },
  iconSet: iconSet,
  // ru: русский UI, понедельник — первый день (KZ/EU), 24ч; даты в полях — DD.MM.YYYY
  lang: langRu,
  extras: ["material-icons"],
  plugins: {
    Notify,
    Dialog,
  },
};
